import React from 'react';
import PropTypes from 'prop-types';
import { useLocomotiveScroll } from 'react-locomotive-scroll';
import useLanguage from '../../../../hooks/useLanguage';

import HomeAboutFooter from './HomeAboutFooter/HomeAboutFooter';
import HomeAboutHeader from './HomeAboutHeader/HomeAboutHeader';
import HomeAboutArticle from './HomeAboutArticle/HomeAboutArticle';
import FreeLessonModal from '../../../UiComponents/FreeLessonModal/FreeLessonModal';

const HomeAbout = ({ aboutData, freeLesson }) => {
  const langToggle = useLanguage;
  const { scroll } = useLocomotiveScroll();
  const [open, setOpen] = React.useState(false);
  function openPopup() {
    setOpen(true);
    scroll.stop();
  }
  function closeModal() {
    setOpen(false);
    scroll.start();
  }
  return (
    <>
      <section className="home-about" data-scroll-section>
        <div className="content-wrapper">
          <HomeAboutHeader aboutData={aboutData} />
          <HomeAboutArticle aboutData={aboutData} />
          <HomeAboutFooter openPopup={openPopup} />
        </div>
      </section>
      <FreeLessonModal
        open={open}
        closeModal={closeModal}
        title={langToggle(freeLesson.title_ua, freeLesson.title_ru)}
      />
    </>
  );
};

HomeAbout.propTypes = {
  aboutData: PropTypes.object,
};

export default HomeAbout;
